import { t } from 'i18next';

import { useGetCategories, useGetCategory } from 'categories/hooks';
import { categoryService } from 'categories/services';
import { TreeFormField } from 'core/components';
import { useFormContext } from 'core/states';

interface IProps {
  name: string;
  label?: string;
  placeholder?: string;
  allItemsLabel?: string;
  // Only categories below the root can be picked, e.g. a Part Finder family's one category.
  isRootExcluded?: boolean;
  required?: boolean;
}

// A category picked from the tree: a search whose options read as paths, above chips that walk
// the tree a level at a time. The one category field of the app, for parts, pricing rules and
// Part Finder families alike.
export const CategoryField = ({
  name,
  label = t('labelCategories'),
  placeholder,
  allItemsLabel,
  isRootExcluded = false,
  required = false,
}: IProps) => {
  const { watch } = useFormContext();

  const selectedItem = watch(name);
  const selectedId = selectedItem?.id;

  const childFilter = selectedId
    ? { filters: { parentId: selectedId } }
    : { filters: { parentId: categoryService.ROOT_CATEGORY_ID } };

  const { record: selectedItemData, isLoading: selectedItemLoading } = useGetCategory(
    { id: selectedId },
    !!selectedId
  );

  const { records: childItems = [], isLoading: childItemsLoading } = useGetCategories(childFilter);

  return (
    <TreeFormField
      name={name}
      label={label}
      placeholder={placeholder}
      allItemsLabel={allItemsLabel}
      required={required}
      getOptions={
        isRootExcluded ? categoryService.getSelectableCategories : categoryService.getCategories
      }
      isLoading={selectedItemLoading || childItemsLoading}
      selectedItem={selectedItemData}
      childItems={childItems}
    />
  );
};
